/**
 * DevExtreme (esm/__internal/viz/core/themes/fluent/index.js)
 * Version: 24.2.5
 * Build date: Fri Feb 14 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
const themes = [{
    baseThemeName: "material.blue.light",
    theme: {
        name: "fluent.blue.light"
    }
}, {
    baseThemeName: "fluent.blue.light",
    theme: {
        name: "fluent.blue.light.compact"
    }
}, {
    baseThemeName: "material.blue.dark",
    theme: {
        name: "fluent.blue.dark"
    }
}, {
    baseThemeName: "fluent.blue.dark",
    theme: {
        name: "fluent.blue.dark.compact"
    }
}];
export default themes;
